module.exports = __webpack_public_path__ + "static/media/B92_Serbia.996a814c.png";